// features/workstations/dashboard-sections/studies.js
// ═══════════════════════════════════════════════════════════
// Studies Confluence (Day Trading)
// ═══════════════════════════════════════════════════════════
// Renders all studies as a grid, anchor studies marked with a
// gold star. Shows the minimum confluence threshold from
// config (e.g. "5 of 8 required").
//
// V1: static "not scored today yet" until session starts.
// V2: each study lights up (sage = confluent, dim = waiting)
// as live market data arrives via Phase 3b.
// ═══════════════════════════════════════════════════════════

import ShiftRead from './shift-read';

export default function StudiesSection({ workstation }) {
  const criteria = workstation?.config?.criteria || {};
  const studies = criteria.studies || [];
  const minConfluence = criteria.minimum_studies_confluence;

  if (studies.length === 0) {
    return null;
  }

  return (
    <section className="ws-section ws-section-studies">
      <div className="ws-section-header">
        <div className="ws-section-label">Studies Confluence</div>
        {minConfluence && (
          <div className="ws-section-tag">
            Minimum {minConfluence} of {studies.length}
          </div>
        )}
      </div>
      <div className="ws-section-body">
        <div className="ws-studies-grid">
          {studies.map((s, i) => (
            <div
              key={i}
              className={`ws-study-card${s.anchor ? ' is-anchor' : ''}`}
              title={s.anchor ? 'Anchor study' : 'Supporting study'}
            >
              <div className="ws-study-card-header">
                {s.anchor && <span className="ws-study-anchor-star">★</span>}
                <span className="ws-study-name">{s.name}</span>
              </div>
              {s.description && (
                <div className="ws-study-desc">{s.description}</div>
              )}
              <div className="ws-study-status ws-study-status-waiting">
                Waiting
              </div>
            </div>
          ))}
        </div>

        <ShiftRead>
          Anchor studies are non-negotiable. No anchor, no trade —
          even if five supporters line up.
        </ShiftRead>
      </div>
    </section>
  );
}
